import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { colours } from 'themes/default';

export const StyledForm = styled.form`
  margin-bottom: ${ifProp({ addBreak: true }, '110px', '0px')};
  p {
    font-size: 24px;
    margin-bottom: 0;
  }
`;
export const StyledInputContainer = styled.div`
  background: ${colours.Greyscale.MistGrey};
  padding: 16px;
  margin-top: 8px;
`;

export const StyledText = styled.div`
  display: inline-block;
  width: 10em;
  font-size: 1.25em;
  color: #2239b5;
`;

export const Errors = styled.div`
  color: red;

  & a {
    color: red;
  }
`;

export const Successes = styled.div`
  color: green;

  & a {
    color: green;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  gap: 5px;
`;
